import classNames from "classnames"
import "./index.less"
import { useEffect, useState } from "react"
import RightPanelTab from "@/global/components/right-panel-tab"
import { ReactComponent as TimeSortSvg } from "../icons/time-sort.svg"
import { Input, InputNumber, Tooltip } from "antd"
import { Sensor, SensorParameter } from "@/global/interface/device/sensor"
import { updateSensorParameter } from "@/api/device/sensor"
import TnMessage from "@/global/components/message"
import SensorParameterWarningSetting from "./param"
import { Transfer2BackEndScale, Transfer2DisplayScale } from "@/global/utils/unit-type"


interface IProps {
    sensor: Sensor

}

export default function WaterThirdPanel(props: IProps) {

    const [activeTab, setActiveTab] = useState<'params' | 'manager' | 'setting'>("params") // 当前激活栏
    const [managerData, setManagerData] = useState<any[]>([]) // 管理信息TODO

    const [sensorParameters, setSensorParameters] = useState<SensorParameter[]>([]) // 传感器参数(水位)

    useEffect(() => {
        // 这里是水位计专属，所以只考虑水位参数
        if (!props?.sensor) {
            return;
        }
        let wlevelParam = props?.sensor?.sensorParameters?.filter(item => item.symbol === 'wlevel') || [];
        let scale = Transfer2DisplayScale("mm");
        wlevelParam?.forEach(item => {
            if (item?.t2) {
                item.t2Dis = scale * item?.t2;
            }
            if (item?.t3) {
                item.t3Dis = scale * item?.t3;
            }
            if (item?.t4) {
                item.t4Dis = scale * item?.t4;
            }
        })
        setSensorParameters(wlevelParam);
    }, [props.sensor])

    const updateParam = (par: SensorParameter) => {
        let idx = sensorParameters?.findIndex(item => item.id === par.id);
        if (idx === -1) return;
        sensorParameters[idx] = par;
        setSensorParameters([...sensorParameters])
    }

    return (
        <div className="water-third">
            <div className="tab-area">
                <RightPanelTab
                    dataList={[
                        { label: "物理参数", value: "params" },
                        // { label: "管理信息", value: "manager" },
                        { label: "设置", value: "setting" },
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
                {activeTab == "manager" && (
                    <Tooltip title="时间升序" placement="bottom">
                        <TimeSortSvg className="icon" />
                    </Tooltip>
                )}
            </div>
            <div className="third-main">
                {activeTab == "params" && (
                    <div className="params-main">
                        <div className="item">
                            <div className="item-name">代号：</div>
                            <div className="item-value">{props.sensor?.code || ''}</div>
                        </div>
                        <div className="item">
                            <div className="item-name">型号：</div>
                            <div className="item-value">{props.sensor?.marking || ''}</div>
                        </div>
                        <div className="item">
                            <div className="item-name">量程：</div>
                            <div className="item-value">{props.sensor?.range || ''}</div>
                        </div>
                        <div className="item">
                            <div className="item-name">精度：</div>
                            <div className="item-value">{props.sensor?.precision || ''}</div>
                        </div>
                    </div>
                )}

                {activeTab == "manager" && (
                    <div className="manager-main">
                        <div className="list">
                            {managerData?.map((item) => (
                                <div className="list-item">
                                    <div>
                                        {"XXXXXXXXXXXXXXXXXXXXXXXX"}
                                    </div>
                                    <div>
                                        {"巡检 XXXXXXXXXXXXXXXXXXXXXXXXX"}
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                )}

                {activeTab == "setting" && (
                    <div className="setting-main">
                        <div className="param">
                            <div className="name header"></div>
                            <div className="cell header">二级预警值</div>
                            <div className="cell sec header">三级预警值</div>
                            <div className="cell third header">四级预警值</div>
                        </div>
                        {sensorParameters?.map(param => (
                            <SensorParameterWarningSetting param={param} updateParam={updateParam} />
                        ))}
                    </div>
                )}

            </div>
        </div>
    )
}